import React, { ReactNode } from "react";
import SimpleTooltip, {
  ITooltip,
} from "apps/website/components/feature/Tooltip/SimpleTooltip";

export function addTooltipArrowOffset(child: ReactNode, arrowOffsetPx?: number) {
  if (React.isValidElement(child) && child.type === SimpleTooltip) {
    return React.cloneElement(child, { arrowOffsetPx } as ITooltip);
  }
  return child;
}
